<div class="container-seat-map">
  <div class="header">
    <div class="box-title"></div>
    <div class="box-header">
    </div>
    <div class="box-flights">
    </div>
    <div class="box-indicators">
      <div class="box-indicator"  *ngFor="let flight of [].constructor(3)">
        <span></span>
      </div>
    </div>
  </div>
  <div class="map">
    <app-seat-map-flight-placeholder></app-seat-map-flight-placeholder>
  </div>
</div>